<template>
  <div class="section-box outline">
    <search-comp>
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect mode="date" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect mode="date" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="das-form-container">
      <div class="das-form-title-container">
        <div class="das-form-title">
          <span class="main-title"> Biểu đồ tròn </span>
        </div>
      </div>
      <div class="chart-container">
        <VChart
          class="chart"
          :option="chartOptions"
          autoresize
          :loading="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'

use([PieChart, TitleComponent, TooltipComponent, LegendComponent])

export default {
  components: {
    CalendarSelect,
    VChart
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: 'Referer of a Website',
          subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          bottom: 20
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 1048, name: 'Search Engine' },
              { value: 735, name: 'Direct' },
              { value: 580, name: 'Email' },
              { value: 484, name: 'Union Ads' },
              { value: 300, name: 'Video Ads' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.chart-container {
  width: 100%;
  display: flex;
  justify-content: center;

  .chart {
    width: 100%;
    height: 500px;
  }
}
</style>
